(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rosilia-global-header"] && !Shopify.designMode) return;
  try {
    (function(){
  var b=document.getElementById('RgMenu'),d=document.getElementById('RgDrawer'),o=document.getElementById('RgOverlay'),c=document.getElementById('RgClose');
  if(!b||!d)return;
  function open(){document.body.classList.add('rg-open');b.setAttribute('aria-expanded','true');d.setAttribute('aria-hidden','false');d.inert=false;c.focus()}
  function close(){document.body.classList.remove('rg-open');b.setAttribute('aria-expanded','false');d.setAttribute('aria-hidden','true');d.inert=true;b.focus()}
  b.addEventListener('click',open); if(o)o.addEventListener('click',close); if(c)c.addEventListener('click',close);
  d.addEventListener('click',function(e){if(e.target.closest('a'))close()});
  document.addEventListener('keydown',function(e){if(!document.body.classList.contains('rg-open'))return;if(e.key==='Escape')close();if(e.key==='Tab'){var items=d.querySelectorAll('a,button');var first=items[0],last=items[items.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}}});
  var shell=document.querySelector('.rg-shell'),lastY=window.scrollY,ticking=false;
  function updateHeader(){
    var y=window.scrollY;
    if(document.body.classList.contains('rg-open')||y<80){shell.classList.remove('rg-hidden');}
    else if(y>lastY+6){shell.classList.add('rg-hidden');}
    else if(y<lastY-6){shell.classList.remove('rg-hidden');}
    lastY=y;ticking=false;
  }
  window.addEventListener('scroll',function(){if(!ticking){window.requestAnimationFrame(updateHeader);ticking=true;}},{passive:true});
})();
  } catch(e) { console.error(e); }
})();

})();
